import React from "react";
import { Link } from "react-router-dom";
import { authService } from "services";
import Logo from "components/Logo";
// import { getAppName } from "utils/utils";

class Restricted extends React.Component {
	componentDidMount() {
		authService.cleanStorage();
	}
	render() {
		// const appName = getAppName();
		const { mode } = this.props;
		const isEndTrial = mode === "end-trial";
		const title = isEndTrial
			? "🎉 Tu periodo de prueba ha terminado"
			: "Acceso restringido";
		const message = isEndTrial
			? `Ha sido un placer acompañarte estos días. Si quieres seguir disfrutando de todo lo que ofrece haddock HR ponte en contacto con nosotros.`
			: `El acceso a ciertas funcionalidades o servicios está sujeto a las restricciones del plan contratado. Contacta con soporte@haddock.app para más información.`;

		return (
			<React.Fragment>
				<div className="page-end-trial container-fluid">
					<Link to="/">
						<Logo className="main-logo" type="logo" />
					</Link>
					<h1>{title}</h1>
					<p>{message}</p>

					<Link className="btn btn-outline-primary" to="/">
						Volver al inicio
					</Link>
				</div>
			</React.Fragment>
		);
	}
}

export default Restricted;
